(function() {
    'use strict';

    window.addEventListener('load', function() {
        var loader = document.getElementById('pageLoader');
        if (loader) loader.classList.add('hidden');
        initCounters();
        initReveal();
        initHeroCarousel();
        initNavbarScroll();
        initReviewSlider();
    });

    function initNavbarScroll() {
        const header = document.getElementById('mainHeader');
        if (!header) return;
        window.addEventListener('scroll', function() {
            const scrollY = window.scrollY;
            if (scrollY > 30) { header.classList.add('scrolled'); } else { header.classList.remove('scrolled'); }
        });
    }

    (function() {
        const toggle = document.querySelector('.mobile-menu-toggle');
        const menu = document.getElementById('mobileMenu');
        if (toggle && menu) {
            toggle.addEventListener('click', function(e) {
                e.stopPropagation();
                menu.classList.toggle('active');
            });
            document.addEventListener('click', function(e) {
                if (!menu.contains(e.target) && !toggle.contains(e.target)) { menu.classList.remove('active'); }
            });
        }
    })();

    function initHeroCarousel() {
        const slides = document.querySelectorAll('.hero-slide');
        const prevBtn = document.querySelector('.hero-carousel-prev');
        const nextBtn = document.querySelector('.hero-carousel-next');
        const indicatorsContainer = document.getElementById('heroIndicators');
        if (!slides.length || !prevBtn || !nextBtn) return;
        let current = 0;
        let interval = null;
        const autoplayDelay = 5000;
        if (indicatorsContainer) {
            indicatorsContainer.innerHTML = '';
            slides.forEach((_, i) => {
                const dot = document.createElement('button');
                dot.className = 'dot' + (i === 0 ? ' active' : '');
                dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
                dot.dataset.index = i;
                dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.index)); resetAutoplay(); });
                indicatorsContainer.appendChild(dot);
            });
        }
        const dots = indicatorsContainer ? indicatorsContainer.querySelectorAll('.dot') : [];
        function goToSlide(index) {
            index = (index + slides.length) % slides.length;
            slides.forEach((s, i) => { s.classList.toggle('active', i === index); });
            dots.forEach((d, i) => { d.classList.toggle('active', i === index); });
            current = index;
        }
        function next() { goToSlide(current + 1); }
        function prev() { goToSlide(current - 1); }
        function startAutoplay() { if (interval) clearInterval(interval); interval = setInterval(next, autoplayDelay); }
        function resetAutoplay() { if (interval) { clearInterval(interval); interval = setInterval(next, autoplayDelay); } }
        prevBtn.addEventListener('click', function() { prev(); resetAutoplay(); });
        nextBtn.addEventListener('click', function() { next(); resetAutoplay(); });
        const wrapper = document.querySelector('.hero-carousel-wrapper');
        if (wrapper) {
            wrapper.addEventListener('mouseenter', function() { if (interval) clearInterval(interval); });
            wrapper.addEventListener('mouseleave', function() { startAutoplay(); });
        }
        startAutoplay();
        goToSlide(0);
    }

    function initCounters() {
        const counters = document.querySelectorAll('.counter-number[data-count]');
        function animateCounters() {
            counters.forEach(c => {
                const target = parseInt(c.getAttribute('data-count'), 10);
                if (target === 0) { c.textContent = '0'; return; }
                let current = 0;
                const step = Math.ceil(target / 60);
                const interval = setInterval(() => {
                    current += step;
                    if (current >= target) { current = target; clearInterval(interval); }
                    c.textContent = current;
                }, 20);
            });
        }
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) { animateCounters(); observer.disconnect(); }
        }, { threshold: 0.3 });
        const section = document.querySelector('.nutrition-counter');
        if (section) observer.observe(section);

        const statNumbers = document.querySelectorAll('.hero-stats .number[data-count]');
        function animateStats() {
            statNumbers.forEach(c => {
                const target = parseInt(c.getAttribute('data-count'), 10);
                const suffix = c.getAttribute('data-suffix') || '';
                let current = 0;
                const step = Math.ceil(target / 50);
                const interval = setInterval(() => {
                    current += step;
                    if (current >= target) { current = target; clearInterval(interval); }
                    c.textContent = current + suffix;
                }, 25);
            });
        }
        const heroObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) { animateStats(); heroObserver.disconnect(); }
        }, { threshold: 0.3 });
        const heroSection = document.querySelector('.hero-section');
        if (heroSection && statNumbers.length) heroObserver.observe(heroSection);
    }

    function initReveal() {
        const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); } });
        }, { threshold: 0.10 });
        els.forEach(el => observer.observe(el));
    }

    const backBtn = document.getElementById('backToTop');
    if (backBtn) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 500) { backBtn.classList.add('visible'); } else { backBtn.classList.remove('visible'); }
        });
        backBtn.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    (function() {
        const track = document.getElementById('whySliderTrack');
        const prevBtn = document.getElementById('whySliderPrev');
        const nextBtn = document.getElementById('whySliderNext');
        if (!track || !prevBtn || !nextBtn) return;
        let autoScroll = null;
        const scrollAmount = () => { const card = track.querySelector('.why-card-slide'); return card ? card.offsetWidth + 20 : 180; };
        function startAutoScroll() {
            if (autoScroll) clearInterval(autoScroll);
            autoScroll = setInterval(() => {
                if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
                else { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); }
            }, 4000);
        }
        function stopAutoScroll() { if (autoScroll) { clearInterval(autoScroll); autoScroll = null; } }
        prevBtn.addEventListener('click', function() { stopAutoScroll(); track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); setTimeout(startAutoScroll, 3000); });
        nextBtn.addEventListener('click', function() { stopAutoScroll(); track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); setTimeout(startAutoScroll, 3000); });
        track.addEventListener('mouseenter', stopAutoScroll);
        track.addEventListener('mouseleave', startAutoScroll);
        startAutoScroll();
    })();

    // (function() {
    //     const bar = document.querySelector('.announcement-bar');
    //     if (!bar) return;
    //     const prevBtn = bar.querySelector('.announcement-nav:first-child');
    //     const nextBtn = bar.querySelector('.announcement-nav:last-child');
    //     const msgs = bar.querySelectorAll('.announcement-msg');
    //     let msgIdx = 0;
    //     function show(i) { msgs.forEach((m, idx) => m.classList.toggle('active', idx === i)); }
    //     if (prevBtn && nextBtn && msgs.length > 1) {
    //         prevBtn.addEventListener('click', function() { msgIdx = (msgIdx - 1 + msgs.length) % msgs.length; show(msgIdx); });
    //         nextBtn.addEventListener('click', function() { msgIdx = (msgIdx + 1) % msgs.length; show(msgIdx); });
    //     } else if (prevBtn && nextBtn) {
    //         prevBtn.style.visibility = 'hidden';
    //         nextBtn.style.visibility = 'hidden';
    //     }
    // })();

    (function() {
        const bar = document.querySelector('.announcement-bar');
        if (!bar) return;
        const prevBtn = bar.querySelector('.announcement-nav:first-child');
        const nextBtn = bar.querySelector('.announcement-nav:last-child');
        const msgs = bar.querySelectorAll('.announcement-msg');
        let msgIdx = 0;
        let autoSlide;
        function show(i) {
            msgs.forEach((m, idx) => {
                m.classList.toggle('active', idx === i);
            });
        }
        function nextSlide() {
            msgIdx = (msgIdx + 1) % msgs.length;
            show(msgIdx);
        }
        function prevSlide() {
            msgIdx = (msgIdx - 1 + msgs.length) % msgs.length;
            show(msgIdx);
        }
        function startAutoSlide() {
            clearInterval(autoSlide);
            autoSlide = setInterval(nextSlide, 3000);
        }
        if (msgs.length > 1) {
            show(msgIdx);
            if (prevBtn) {
                prevBtn.addEventListener('click', function() {
                    prevSlide();
                    startAutoSlide();
                });
            }
            if (nextBtn) {
                nextBtn.addEventListener('click', function() {
                    nextSlide();
                    startAutoSlide();
                });
            }
            startAutoSlide();
        } else {
            if (prevBtn) prevBtn.style.visibility = 'hidden';
            if (nextBtn) nextBtn.style.visibility = 'hidden';
        }
    })();

    (function() {
        const greetingEl = document.getElementById('greetingMessage');
        if (!greetingEl) return;
        function getGreeting(hours) {
            if (hours >= 5 && hours < 12) return 'Good Morning!';
            if (hours >= 12 && hours < 17) return 'Good Afternoon!';
            if (hours >= 17 && hours < 21) return 'Good Evening!';
            return 'Good Night!';
        }
        function updateGreeting() {
            const now = new Date();
            const newGreeting = getGreeting(now.getHours());
            if (greetingEl.textContent !== newGreeting) { greetingEl.textContent = newGreeting; }
        }
        updateGreeting();
        setInterval(updateGreeting, 60000);
        document.addEventListener('visibilitychange', function() { if (!document.hidden) updateGreeting(); });
    })();

    (function() {
        const items = document.querySelectorAll('.gallery-item');
        const galleryObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); galleryObserver.unobserve(entry.target); } });
        }, { threshold: 0.10 });
        items.forEach((el, i) => { el.classList.add('delay-' + ((i % 7) + 1)); galleryObserver.observe(el); });

        const contentEl = document.getElementById('aboutContent');
        if (contentEl) {
            const obs2 = new IntersectionObserver((entries) => {
                entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); obs2.unobserve(entry.target); } });
            }, { threshold: 0.15 });
            obs2.observe(contentEl);
        }
    })();

    document.querySelectorAll('a[href^="#"]').forEach(a => {
        a.addEventListener('click', function(e) {
            const target = document.querySelector(this.getAttribute('href'));
            if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
        });
    });

    function initReviewSlider() {
        const track = document.getElementById('reviewSliderTrack');
        const dotsContainer = document.getElementById('reviewDots');
        const prevBtn = document.getElementById('reviewPrev');
        const nextBtn = document.getElementById('reviewNext');
        const wrapper = document.getElementById('reviewSliderWrapper');
        if (!track || !dotsContainer || !prevBtn || !nextBtn || !wrapper) return;

        const slides = track.querySelectorAll('.review-slide');
        const totalSlides = slides.length;
        if (totalSlides === 0) {
            prevBtn.disabled = true;
            nextBtn.disabled = true;
            return;
        }

        let currentSlide = 0;
        let autoInterval = null;
        const autoplayDelay = 6000;
        let isDragging = false;
        let startX = 0;
        let currentTranslate = 0;

        function getVisibleCount() { if (window.innerWidth >= 992) return 3; if (window.innerWidth >= 576) return 2; return 1; }
        function updateButtons() { prevBtn.disabled = (currentSlide === 0); nextBtn.disabled = (currentSlide >= totalSlides - 1); }

        function goToSlide(index, animate = true) {
            index = Math.max(0, Math.min(index, totalSlides - 1));
            currentSlide = index;
            const visible = getVisibleCount();
            const slideWidth = 100 / visible;
            const offset = -index * slideWidth;
            track.style.transition = animate ? 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
            track.style.transform = `translateX(${offset}%)`;
            const dots = dotsContainer.querySelectorAll('.dot');
            dots.forEach((d, i) => { d.classList.toggle('active', i === index); });
            updateButtons();
        }

        function nextSlide() { if (currentSlide < totalSlides - 1) { goToSlide(currentSlide + 1); } else { goToSlide(0); } }
        function prevSlide() { if (currentSlide > 0) { goToSlide(currentSlide - 1); } else { goToSlide(totalSlides - 1); } }
        function startAutoplay() { if (autoInterval) clearInterval(autoInterval); if (totalSlides > 1) { autoInterval = setInterval(nextSlide, autoplayDelay); } }
        function stopAutoplay() { if (autoInterval) { clearInterval(autoInterval); autoInterval = null; } }
        function resetAutoplay() { stopAutoplay(); startAutoplay(); }

        dotsContainer.querySelectorAll('.dot').forEach(dot => {
            dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.index)); resetAutoplay(); });
        });

        function handleTouchStart(e) {
            if (e.touches.length === 1) { isDragging = true; startX = e.touches[0].clientX; track.style.transition = 'none'; const visible = getVisibleCount(); const slideWidth = 100 / visible; currentTranslate = -currentSlide * slideWidth; }
        }
        function handleTouchMove(e) {
            if (!isDragging || e.touches.length !== 1) return;
            const diff = (e.touches[0].clientX - startX) / track.offsetWidth * 100;
            const visible = getVisibleCount(); const slideWidth = 100 / visible;
            let newTranslate = currentTranslate + diff;
            const maxTranslate = 0; const minTranslate = -(totalSlides - 1) * slideWidth;
            newTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
            track.style.transform = `translateX(${newTranslate}%)`;
        }
        function handleTouchEnd(e) {
            if (!isDragging) return;
            isDragging = false;
            const diff = (e.changedTouches[0].clientX - startX);
            const threshold = 30;
            if (diff < -threshold && currentSlide < totalSlides - 1) { goToSlide(currentSlide + 1); }
            else if (diff > threshold && currentSlide > 0) { goToSlide(currentSlide - 1); }
            else { goToSlide(currentSlide); }
            resetAutoplay();
        }
        function handleResize() { goToSlide(currentSlide, false); }

        prevBtn.addEventListener('click', function() { prevSlide(); resetAutoplay(); });
        nextBtn.addEventListener('click', function() { nextSlide(); resetAutoplay(); });
        wrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
        wrapper.addEventListener('touchmove', handleTouchMove, { passive: true });
        wrapper.addEventListener('touchend', handleTouchEnd, { passive: true });

        let mouseDown = false;
        let mouseStartX = 0;
        wrapper.addEventListener('mousedown', function(e) {
            mouseDown = true; mouseStartX = e.clientX; track.style.transition = 'none';
            const visible = getVisibleCount(); const slideWidth = 100 / visible; currentTranslate = -currentSlide * slideWidth;
        });
        window.addEventListener('mousemove', function(e) {
            if (!mouseDown) return;
            const diff = (e.clientX - mouseStartX) / track.offsetWidth * 100;
            const visible = getVisibleCount(); const slideWidth = 100 / visible;
            let newTranslate = currentTranslate + diff;
            const maxTranslate = 0; const minTranslate = -(totalSlides - 1) * slideWidth;
            newTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
            track.style.transform = `translateX(${newTranslate}%)`;
        });
        window.addEventListener('mouseup', function(e) {
            if (!mouseDown) return;
            mouseDown = false;
            const diff = (e.clientX - mouseStartX);
            const threshold = 30;
            if (diff < -threshold && currentSlide < totalSlides - 1) { goToSlide(currentSlide + 1); }
            else if (diff > threshold && currentSlide > 0) { goToSlide(currentSlide - 1); }
            else { goToSlide(currentSlide); }
            resetAutoplay();
        });

        let resizeTimer;
        window.addEventListener('resize', function() { clearTimeout(resizeTimer); resizeTimer = setTimeout(handleResize, 150); });
        wrapper.addEventListener('mouseenter', stopAutoplay);
        wrapper.addEventListener('mouseleave', startAutoplay);

        goToSlide(0, false);
        startAutoplay();
    }

    console.log('The Honest Mill loaded.');
})();
